import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchBlogPost } from "../lib/opinly";
import { BlogArticle } from "../components/blog/BlogArticle";
import { BlogError, BlogPostSkeleton } from "../components/blog/BlogStates";
import NotFound from "./NotFound";

export default function BlogPost() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: "loading" });

  const load = useCallback(() => {
    setState({ status: "loading" });
    fetchBlogPost(slug)
      .then((d) => setState({ status: "ready", post: d.post, imagesPrefix: d.images_prefix }))
      .catch((err) => setState({ status: err?.response?.status === 404 ? "notfound" : "error" }));
  }, [slug]);

  useEffect(() => { load(); }, [load]);

  if (state.status === "loading") return <BlogPostSkeleton />;
  if (state.status === "notfound") return <NotFound />;
  if (state.status === "error") {
    return (
      <div className="mps-container max-w-3xl py-16 md:py-20" data-testid="blog-post-error-page">
        <BlogError onRetry={load} />
      </div>
    );
  }
  return <BlogArticle key={state.post.slug} post={state.post} imagesPrefix={state.imagesPrefix} />;
}
